module.exports = __webpack_public_path__ + "img/70eef91.webp";